import axios, { AxiosHeaders, AxiosInstance, Method, RawAxiosRequestHeaders, AxiosRequestConfig } from 'axios';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const axiosInstanceDefault = axios.create({
	baseURL: BASE_URL,
	headers: { 'Content-Type': 'application/json' },
});

const useAxiosFunction = () => {
	const [response, setResponse] = useState<any>();
	const [error, setError] = useState<any>();
	const [loading, setLoading] = useState(false);
	const [controller, setController] = useState();

	const axiosFetch = async (configObj: {
		axiosInstance?: { baseURL: string; headers: RawAxiosRequestHeaders | AxiosHeaders };
		method: Method;
		url: string;
		body?: object;
		params?: object;
		headers?: RawAxiosRequestHeaders | AxiosHeaders;
		/** Additional axios options (merged directly). */
		opt?: AxiosRequestConfig;
		/**
		 * Optional per-request timeout (ms). If provided it overrides any opt.timeout.
		 */
		timeout?: number;
	}) => {
		const { axiosInstance, method, url, body = {}, headers = {}, params = {}, opt = {}, timeout } = configObj;
		const axiosInstanceToUse = axiosInstance ? axios.create(axiosInstance) : axiosInstanceDefault;
		try {
			setLoading(true);
			const ctrl = new AbortController();

			// @ts-expect-error
			setController(ctrl);

			// Merge timeout preference
			const mergedOpt: AxiosRequestConfig = { ...opt };
			if (timeout) {
				mergedOpt.timeout = timeout;
			} else if (opt && (opt as any).timeout) {
				// already present
			}
			const res = await getAxiosCall(axiosInstanceToUse, url, method, ctrl, { headers, body, params, opt: mergedOpt });

			if (res) {
				setResponse(res.data);
				return res.data;
			}
		} catch (err: any) {
			setError(err?.response ?? err);
			if (err.code !== "ERR_CANCELED") {
				return Promise.reject(err?.response ?? err);
			}
			if (err.code == "ERR_NETWORK") {
				return toast.error('Network error: No internet.');
			}

		} finally {
			setLoading(false);
		}
	};

	const getAxiosCall = (axiosInstanceToUse: AxiosInstance, url: string, method: Method, ctrl: AbortController, options?: { headers: RawAxiosRequestHeaders | AxiosHeaders, body: object, params: object, opt: object }) => {
		const methodCall = method.toLowerCase();

		const axiosOptions = {
			...options?.opt,
			headers: options?.headers,
			params: options?.params,
			signal: ctrl.signal
		}
		switch (methodCall) {
			case 'get':
			case 'delete':
			case 'head':
			case 'options':
				return axiosInstanceToUse[methodCall](url, axiosOptions);

			case 'post':
			case 'put':
			case 'patch':
				return axiosInstanceToUse[methodCall](url, options?.body, axiosOptions);

			default:
				break;
		}
	}

	useEffect(() => {

		// useEffect cleanup function

		// @ts-expect-error

		return () => controller && controller.abort();
	}, [controller]);

	return [ response, error, loading, axiosFetch ] as const;
};

export default useAxiosFunction;
